import React from 'react'
import { useIntl } from 'react-intl'
import { Container, Typography, Box, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'

import { LoginFormComponent } from '../../../features/login'
import { ReactComponent as LogoNedgiaFull } from '../../../resources/images/logo_nedgia_full.svg'
import { APP_VERSION_MSSG } from '../constants'

const StyledLogo = styled(LogoNedgiaFull)({
  width: 233,
  height: 104,
})

export const LoginPage = () => {
  const { formatMessage } = useIntl()

  return (
    <Box sx={{ height: '100vh', display: 'flex' }}>
      <Box
        sx={{
          width: '50%',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundImage: 'url("images/auth_bg.png")',
          display: { xs: 'none', xl: 'block' },
        }}
      />
      <Box
        sx={(theme) => ({
          backgroundColor: '#FFFFFF',
          flex: 1,
          [theme.breakpoints.down('lg')]: {
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundImage: 'url("images/auth_bg.png")',
          },
          [theme.breakpoints.down('md')]: {
            backgroundImage: 'none',
            backgroundColor: '#f3f3f3',
          },
        })}
      >
        <Container
          maxWidth="sm"
          sx={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box
            sx={(theme) => ({
              margin: '20px 0',
              padding: '30px 60px',
              borderRadius: '4px',
              backgroundColor: '#FFFFFF',
              [theme.breakpoints.down('md')]: {
                padding: '20px',
              },
            })}
          >
            <Box mb={6} textAlign="center">
              <Tooltip title={APP_VERSION_MSSG}>
                <StyledLogo />
              </Tooltip>
            </Box>
            <Box mb={4}>
              <Typography variant="h5">{formatMessage({ id: 'pages.login.title' })}</Typography>
            </Box>
            <Box
              sx={(theme) => ({
                width: '100%',
                [theme.breakpoints.up('sm')]: {
                  width: 370,
                },
              })}
            >
              <LoginFormComponent />
            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  )
}
